
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDButton from 'components/MDButton';
import MDInput from "components/MDInput";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';
// import Select from 'react-select';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TextField } from "@mui/material";
import * as moment from 'moment';
import * as service from '../../../services/service';

function AddEditWorkOrder() {
    const [state, setState] = useState({
        workorderno: '', workorderamount: '', workorderfilename: '', workorderfilepath: '',
        completionfilename: '', completionfilepath: '', invoicefilename: '', invoicefilepath: '', invoiceamount: '0',
        govtapprovalno: '', govtapprovalfilename: '', govtapprovalfilepath: '',
        financialapprovalno: '', financialapprovalfilename: '', financialapprovalfilepath: '', nastinumber: ''
    });
    const [data, setData] = useState([]);
    const [workOrderDate, setWorkOrderDate] = useState(new Date());
    const [workOrderFile, setWorkOrderFile] = useState('');
    const [completionFile, setCompletionFile] = useState('');
    const [invoiceFile, setInvoiceFile] = useState('');
    const [govtApprovalDate, setGovtApprovalDate] = useState(new Date());
    const [govtApprovalFile, setGovtApprovalFile] = useState('');
    const [financialApprovalDate, setFinancialApprovalDate] = useState(new Date());
    const [financialApprovalFile, setFinancialApprovalFile] = useState('');
    const [workOrderId, setWorkOrderId] = useState('');
    const [errors, setError] = useState({});
    const [loading, setLoading] = useState(false);
    // const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };
    const eventName = JSON.parse(localStorage.getItem('eventname'))
    const categoryName = JSON.parse(localStorage.getItem('categoryname'))
    const agencyName = JSON.parse(localStorage.getItem('agencyname'))
    const eventExecution = JSON.parse(localStorage.getItem('eventexecution'))
    const quotationAmount = JSON.parse(localStorage.getItem('quotationamount'))
    const navigate = useNavigate();
    const { quotationId, eventId } = useParams();

    const getWorkOrderDetails = () => {
        fetch(
            service.GET_WORK_ORDER_BY_EVENT_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                },
                body: JSON.stringify({
                    EventId: eventId,
                })
            })
            .then(res => res.json())
            .then(result => {
                setData(result);
                if (result.length === 0) {
                    setError('No Data Found');
                }
            })
            .catch(err => {
                if (err) {
                    setError(err);
                };
            });
    };

    const getDetailsById = (id) => {
        setLoading(true);
        const errs = {};
        if (id > 0) {
            fetch(
                service.GET_WORK_ORDER_BY_ID,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                    },
                    body: JSON.stringify({
                        WorkOrderId: id,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.message.messageType === 'Success') {
                        setState({
                            ...state, workorderno: result.workOrderNo, workorderamount: result.workOrderAmount,
                            workorderfilename: result.workOrderFileName, workorderfilepath: result.workOrderFilePath,
                            completionfilename: result.completionFileName, completionfilepath: result.completionFilePath,
                            invoicefilename: result.invoiceFileName, invoicefilepath: result.invoiceFilePath, invoiceamount: result.invoiceAmount,
                            govtapprovalno: result.govtApprovalNo, govtapprovalfilename: result.govtApprovalFileName,
                            govtapprovalfilepath: result.govtApprovalFilePath,
                            financialapprovalno: result.financialApprovalNo, financialapprovalfilename: result.financialApprovalFileName,
                            financialapprovalfilepath: result.financialApprovalFilePath, nastinumber: result.nastiNumber
                        });
                        setWorkOrderDate(new Date(result.workOrderDate));
                        setGovtApprovalDate(new Date(result.govtApprovalDate));
                        setFinancialApprovalDate(new Date(result.financialApprovalDate));
                        setWorkOrderId(id);
                    }
                    else {
                        errs[".invalid"] = result.message.message;
                        setError(errs);
                    }

                });
        }
        setLoading(false);
    };

    useEffect(() => {
        if (eventId > 0) {
            getWorkOrderDetails();
        }
    }, []);

    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!state.workorderno) {
            isValid = false;
            errs[".workorderno"] = "Please enter work order no";
        }
        if (!state.workorderamount) {
            isValid = false;
            errs[".workorderamount"] = "Please enter work order amount";
        }
        if (!workOrderDate) {
            isValid = false;
            errs[".workOrderDate"] = "Please enter work order date";
        }
        setError(errs);
        return isValid;
    }
    const changeHandler = (event) => {
        if (event.target.name === 'workorderamount' || event.target.name === 'invoiceamount') {
            if (Number.isNaN(parseFloat(event.target.value))) {
                // eslint-disable-next-line
                alert("Please enter numbers only");
                event.target.value = ""; // eslint-disable-line no-param-reassign
            }
        }
        setState({ ...state, [event.target.name]: event.target.value });
    };

    const handleDownload = (fileName, filePath) => {
        setLoading(true);
        const formData = new FormData();
        formData.append("FileName", fileName);
        formData.append("FilePath", filePath);
        fetch(
            service.DOWNLOAD_FILE,
            {
                method: 'POST',
                headers: {
                    'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                },
                body: formData
            })
            .then((response) => response.blob())
            .then((blob) => {
                // Create blob link to download
                const url = window.URL.createObjectURL(
                    new Blob([blob]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    fileName,
                );
                // Append to html link element page
                document.body.appendChild(link);
                // Start download
                link.click();
                // Clean up and remove the link
                link.parentNode.removeChild(link);
            });

        setLoading(false);
    };

    const submitHandler = e => {
        e.preventDefault();
        const errs = {};
        setLoading(true);
        if (validate()) {
            const formData = new FormData();
            formData.append("WorkOrderId", workOrderId > 0 ? workOrderId : 0);
            formData.append("QuotationId", quotationId);
            formData.append("EventId", eventId);
            formData.append("WorkOrderDate", (new Date(workOrderDate)).toUTCString());
            formData.append("WorkOrderNo", state.workorderno);
            formData.append("WorkOrderAmount", state.workorderamount);
            formData.append("InvoiceAmount", state.invoiceamount);
            formData.append("GovtApprovalNo", state.govtapprovalno);
            formData.append("GovtApprovalDate", (new Date(govtApprovalDate)).toUTCString());
            formData.append("FinancialApprovalNo", state.financialapprovalno);
            formData.append("FinancialApprovalDate", (new Date(financialApprovalDate)).toUTCString());
            formData.append("WorkOrderFile", workOrderFile);
            formData.append("CompletionFile", completionFile);
            formData.append("InvoiceFile", invoiceFile);
            formData.append("GovtApprovalFile", govtApprovalFile);
            formData.append("FinancialApprovalFile", financialApprovalFile);
            formData.append("NastiNumber", state.nastinumber);
            formData.append("AddedBy", JSON.parse(window.sessionStorage.getItem('userData')).userId);
            formData.append("UpdatedBy", JSON.parse(window.sessionStorage.getItem('userData')).userId);
            fetch(
                service.ADD_UPDATE_WORK_ORDER,
                {
                    method: 'POST',
                    headers: {
                        'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                    },
                    body: formData
                })
                .then(res => res.json())
                .then(result => {
                    if (result.messageType === 'Success') {
                        // eslint-disable-next-line
                        alert(result.message);
                        window.location.reload();
                    }
                    else if (result.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(result.message);
                    }
                    else {
                        errs[".invalid"] = result.message.message;
                        setError(errs);
                    }
                });
        }
        setLoading(false);
    }

    const backHandler = () => {
        localStorage.setItem('agencyname', null);
        localStorage.setItem('quotationamount', null);
        navigate(`/addeditquotations/${eventId}`);
    }

    const handleEdit = (id) => {
        getDetailsById(id);
    }

    const handlePayment = (woId, woNo, amt, invamt) => {
        localStorage.setItem('quotationid', quotationId);
        localStorage.setItem('workorderno', JSON.stringify(woNo));
        localStorage.setItem('workorderamount', JSON.stringify(amt));
        localStorage.setItem('invoiceamount', JSON.stringify(invamt));
        localStorage.setItem('eventexecution', JSON.stringify(eventExecution));
        navigate(`/addeditpayment/${woId}/${eventId}`);
    }

    const handleInvoice = (woId, woNo, amt) => {
        localStorage.setItem('quotationid', quotationId);
        localStorage.setItem('workorderno', JSON.stringify(woNo));
        localStorage.setItem('workorderamount', JSON.stringify(amt));
        localStorage.setItem('tenderamount', JSON.stringify(quotationAmount));
        localStorage.setItem('eventexecution', JSON.stringify(eventExecution));
        navigate(`/addeditinvoice/${woId}/${eventId}`);
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Work Order Details
                                </MDTypography>
                            </MDBox>
                            <Card style={{ alignItems: 'center' }}>
                                {/* <TableContainer component={Paper} style={{ width: '90%', alignSelf: 'center', }}> */}
                                <Table>
                                    <TableRow>
                                        <TableCell width="50%" style={{ fontWeight: 'bold' }}>
                                            Event Category : {categoryName}
                                        </TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>
                                            Event Name : {eventName}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ fontWeight: 'bold' }}>
                                            Event Execution : {eventExecution}
                                        </TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>
                                            Agency Name : {agencyName}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        {eventExecution === 'Quotation' ?
                                            <TableCell style={{ fontWeight: 'bold' }}>
                                                Quotation Amount : {quotationAmount}
                                            </TableCell>
                                            : <TableCell style={{ fontWeight: 'bold' }}>
                                                Tender Amount : {quotationAmount}
                                            </TableCell>}
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <MDInput label="Work Order No." fullWidth value={state.workorderno || ''}
                                                name="workorderno"
                                                onChange={changeHandler}
                                                id="workorderno"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".workorderno"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <MDInput label="Work Order Amount" fullWidth value={state.workorderamount || ''}
                                                name="workorderamount"
                                                onChange={changeHandler}
                                                id="workorderamount"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".workorderamount"]}</div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <div> Work Order Date </div>
                                            <DatePicker
                                                id="workOrderDate"
                                                selected={workOrderDate}
                                                onChange={date => setWorkOrderDate(date)}
                                                dateFormat="MM/dd/yyyy"
                                                tabIndex={0}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".workOrderDate"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <div>Upload Work Order File (File Size 5 MB)</div>
                                            <TextField
                                                id="workOrderFile"
                                                type="file"
                                                onChange={ev => setWorkOrderFile(ev.target.files[0])}
                                                style={{ width: 200 }}
                                                required
                                            />
                                            {state.workorderfilename ?
                                                <MDButton onClick={() => handleDownload(state.workorderfilename, state.workorderfilepath)}>{state.workorderfilename}</MDButton>
                                                : null}
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".workOrderFile"]}</div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <MDInput label="Govt Approval No. (Administrative)" fullWidth value={state.govtapprovalno || ''}
                                                name="govtapprovalno"
                                                onChange={changeHandler}
                                                id="govtapprovalno"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".govtapprovalno"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <div> Govt Approval Date (Administrative)</div>
                                            <DatePicker
                                                id="govtApprovalDate"
                                                selected={govtApprovalDate}
                                                onChange={date => setGovtApprovalDate(date)}
                                                dateFormat="MM/dd/yyyy"
                                                tabIndex={0}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".govtApprovalDate"]}</div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <div>Upload Govt Approval File (Administrative) (File Size 5 MB)</div>
                                            <TextField
                                                id="govtApprovalFile"
                                                type="file"
                                                onChange={ev => setGovtApprovalFile(ev.target.files[0])}
                                                style={{ width: 200 }}
                                                required
                                            />
                                            {state.govtapprovalfilename ?
                                                <MDButton onClick={() => handleDownload(state.govtapprovalfilename, state.govtapprovalfilepath)}>{state.govtapprovalfilename}</MDButton>
                                                : null}
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".govtApprovalFile"]}</div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <MDInput label="Govt Approval No. (Financial)" fullWidth value={state.financialapprovalno || ''}
                                                name="financialapprovalno"
                                                onChange={changeHandler}
                                                id="financialapprovalno"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".financialapprovalno"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <div> Govt Approval Date (Financial)</div>
                                            <DatePicker
                                                id="financialApprovalDate"
                                                selected={financialApprovalDate}
                                                onChange={date => setFinancialApprovalDate(date)}
                                                dateFormat="MM/dd/yyyy"
                                                tabIndex={0}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".financialApprovalDate"]}</div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <div>Upload Govt Approval File (Financial) (File Size 5 MB)</div>
                                            <TextField
                                                id="financialApprovalFile"
                                                type="file"
                                                onChange={ev => setFinancialApprovalFile(ev.target.files[0])}
                                                style={{ width: 200 }}
                                                required
                                            />
                                            {state.financialapprovalfilename ?
                                                <MDButton onClick={() => handleDownload(state.financialapprovalfilename, state.financialapprovalfilepath)}>{state.financialapprovalfilename}</MDButton>
                                                : null}
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".financialApprovalFile"]}</div>
                                        </TableCell>
                                        <TableCell>
                                            <MDInput label="Nasti Number" fullWidth value={state.nastinumber || ''}
                                                name="nastinumber"
                                                onChange={changeHandler}
                                                id="nastinumber"
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".nastinumber"]}</div>
                                        </TableCell>
                                    </TableRow>
                                    {eventExecution === 'Quotation' ?
                                        <TableRow>
                                            <TableCell>
                                                <div>Upload Completion File (File Size 5 MB)</div>
                                                <TextField
                                                    id="completionFile"
                                                    type="file"
                                                    onChange={ev => setCompletionFile(ev.target.files[0])}
                                                    style={{ width: 200 }}
                                                    required
                                                />
                                                {state.completionfilename ?
                                                    <MDButton onClick={() => handleDownload(state.completionfilename, state.completionfilepath)}>{state.completionfilename}</MDButton>
                                                    : null}
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".completionFile"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                <div>Upload Invoice File (File Size 5 MB)</div>
                                                <TextField
                                                    id="invoiceFile"
                                                    type="file"
                                                    onChange={ev => setInvoiceFile(ev.target.files[0])}
                                                    style={{ width: 200 }}
                                                    required
                                                />
                                                {state.invoicefilename ?
                                                    <MDButton onClick={() => handleDownload(state.invoicefilename, state.invoicefilepath)}>{state.invoicefilename}</MDButton>
                                                    : null}
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invoiceFile"]}</div>
                                            </TableCell>
                                        </TableRow> : null}
                                    {eventExecution === 'Quotation' ?
                                        <TableRow>
                                            <TableCell>
                                                <MDInput label="Invoice Amount" fullWidth value={state.invoiceamount || ''}
                                                    name="invoiceamount"
                                                    onChange={changeHandler}
                                                    id="invoiceamount"
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invoiceamount"]}</div>
                                            </TableCell>
                                        </TableRow> : null
                                    }
                                </Table>
                                {/* </TableContainer> */}
                                <MDBox mt={4} mb={1} textAlign="center">
                                    {loading ? <Oval
                                        heigth="20"
                                        width="20"
                                        color='grey'
                                        ariaLabel='loading'
                                    /> :
                                        <div>
                                            <MDButton color="info" onClick={submitHandler}>
                                                SAVE
                                            </MDButton>  &nbsp;&nbsp;&nbsp;&nbsp;
                                            <MDButton color="info" onClick={backHandler}>
                                                BACK
                                            </MDButton>
                                        </div>
                                    }
                                    {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                </MDBox>
                            </Card>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                {loading ? <Oval
                                    heigth="100"
                                    width="100"
                                    color='grey'
                                    ariaLabel='loading'
                                /> :
                                    <TableContainer component={Paper} style={{ width: '95%', alignSelf: 'center', }}>
                                        <Table aria-label="simple table">
                                            <TableRow style={{ backgroundColor: 'lightgrey' }}>
                                                <TableCell style={{ fontWeight: 'bold' }}>Work Order No.</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Work Order Amount</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Work Order Date</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Work Order File</TableCell>
                                                {eventExecution === 'Quotation' ? <TableCell style={{ fontWeight: 'bold' }}>Completion File</TableCell> : null}
                                                {eventExecution === 'Quotation' ? <TableCell style={{ fontWeight: 'bold' }}>Invoice File</TableCell> : null}
                                                {eventExecution === 'Quotation' ? <TableCell style={{ fontWeight: 'bold' }}>Invoice Amount</TableCell> : null}
                                                <TableCell colSpan="3" align="center" style={{ fontWeight: 'bold' }}>Action</TableCell>
                                            </TableRow>
                                            <TableBody>
                                                {data.map((row) => (
                                                    <TableRow
                                                        key={row.workOrderId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell width="10%" component="th" scope="row">{row.workOrderNo}</TableCell>
                                                        <TableCell width="15%" component="th" scope="row">{row.workOrderAmount}</TableCell>
                                                        <TableCell width="10%" component="th" scope="row">{moment(row.workOrderDate).format('DD/MM/YYYY')}</TableCell>
                                                        <TableCell width="15%" component="th" scope="row"><MDButton onClick={() => handleDownload(row.workOrderFileName, row.workOrderFilePath)}>{row.workOrderFileName}</MDButton></TableCell>
                                                        {eventExecution === 'Quotation' ? <TableCell width="15%" component="th" scope="row"><MDButton onClick={() => handleDownload(row.completionFileName, row.completionFilePath)}>{row.completionFileName}</MDButton></TableCell> : null}
                                                        {eventExecution === 'Quotation' ? <TableCell width="15%" component="th" scope="row"><MDButton onClick={() => handleDownload(row.invoiceFileName, row.invoiceFilePath)}>{row.invoiceFileName}</MDButton></TableCell> : null}
                                                        {eventExecution === 'Quotation' ? <TableCell width="15%" component="th" scope="row">{row.invoiceAmount}</TableCell> : null}
                                                        <TableCell><MDButton onClick={() => handleEdit(row.workOrderId)}>Edit</MDButton></TableCell>
                                                        {eventExecution !== 'Quotation' ? <TableCell><MDButton onClick={() => handleInvoice(row.workOrderId, row.workOrderNo, row.workOrderAmount)}>Invoice Details</MDButton></TableCell> : null}
                                                        <TableCell><MDButton onClick={() => handlePayment(row.workOrderId, row.workOrderNo, row.workOrderAmount, row.invoiceAmount)}>Payment Details</MDButton></TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default AddEditWorkOrder;